export default __webpack_public_path__ + "4c10b3a9e4c75713100365a1cb06122b.png";